(() => {
  const selector = [
    "main[data-template^='product'] .product-information__media media-gallery .slideshow-controls__dots",
    '.card-gallery .slideshow-controls__dots',
  ].join(',');

  const setup = (list) => {
    if (!(list instanceof HTMLOListElement) || list.dataset.aryThreeDotReady === 'true') return;

    const buttons = Array.from(list.querySelectorAll(':scope > li > button'));
    if (!buttons.length) return;

    list.dataset.aryThreeDotReady = 'true';

    if (buttons.length <= 3) {
      list.classList.add('ary-compact-native-dots');
      return;
    }

    list.classList.add('ary-three-dot-mode');

    const markers = Array.from({ length: 3 }, () => {
      const item = document.createElement('li');
      item.className = 'ary-mobile-gallery-dot';
      item.setAttribute('aria-hidden', 'true');
      list.appendChild(item);
      return item;
    });

    const update = () => {
      let activeIndex = buttons.findIndex((button) => button.getAttribute('aria-selected') === 'true');
      if (activeIndex < 0) activeIndex = 0;

      const lastIndex = buttons.length - 1;
      const bucket = lastIndex <= 0 ? 0 : Math.min(2, Math.round((activeIndex / lastIndex) * 2));

      markers.forEach((marker, index) => {
        if (index === bucket) {
          marker.setAttribute('aria-current', 'true');
        } else {
          marker.removeAttribute('aria-current');
        }
      });
    };

    const dotObserver = new MutationObserver(update);
    buttons.forEach((button) => {
      dotObserver.observe(button, {
        attributes: true,
        attributeFilter: ['aria-selected'],
      });
    });

    update();
  };

  const init = (root = document) => {
    if (root instanceof Element && root.matches(selector)) setup(root);
    root.querySelectorAll?.(selector).forEach(setup);
  };

  const start = () => {
    init();

    const pageObserver = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node instanceof Element) init(node);
        }
      }
    });

    pageObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) init(event.target);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
